import { useState } from 'react';
import { Button, Flex, FormControl, FormLabel, Input, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import Pagination from 'components/Pagination/Pagination';
import { useQueryGetSystemNotification } from 'services/system-notification';
import Table from './components/Table';
import { Select } from 'chakra-react-select';
import { SystemNotiOptions } from 'constants/common';

export default function SystemNotification() {
  const history = useHistory();
  const textColor = useColorModeValue('gray.700', 'white');
  const [filter, setFilter] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [searchTitle, setSearchTitle] = useState('');
  const [type, setType] = useState();

  const { data: notification, refetch } = useQueryGetSystemNotification(filter);

  const handleSearch = () => {
    setFilter({
      ...filter,
      type: type?.value,
      searchKeyword: searchTitle
    });
  };

  const handleReset = () => {
    setFilter({
      pageIndex: 0,
      pageSize: 10,
    });
    setType(null);
    setSearchTitle('');
  };

  return (
    <>
      <Flex direction="column" pt={{ base: '120px', md: '75px', lg: '100px' }}>
        <Card p="16px" mb="24px" bg="#fff">
          <CardHeader p="12px 5px" mb="12px">
            <Flex justifyContent={'space-between'}>
              <Flex direction={'column'}>
                <Flex direction="column" gap={'30px'}>
                  <Text fontSize="xl" color={textColor} fontWeight="bold">
                    Thông báo cài đặt
                  </Text>
                </Flex>
              </Flex>
              <Flex gap={2}>
                <Button
                  bg="#3182ce"
                  color="#fff"
                  _hover={{ bg: '#67a1d7' }}
                  onClick={() => {
                    history.push('/admin/system-noti/create');
                  }}
                >
                  <Text fontSize="md" fontWeight="bold" cursor="pointer">
                    Thêm
                  </Text>
                </Button>
              </Flex>
            </Flex>
            <Flex flex wrap="wrap" alignItems={'center'} gap={4} my={3}>
              <FormControl w={'300px'}>
                <FormLabel>Tìm kiếm thông báo</FormLabel>
                <Input value={searchTitle} onChange={e => setSearchTitle(e.target.value)} />
              </FormControl>
              <FormControl w={'250px'}>
                <FormLabel h={'21px'}>Thể loại</FormLabel>
                <Select
                  placeholder="Chọn thể loại"
                  isClearable
                  menuShouldBlockScroll
                  value={type}
                  onChange={e => {
                    setType(e);
                  }}
                  options={SystemNotiOptions}
                ></Select>
              </FormControl>
              <Button variant="primary" maxH="40px" alignSelf={'end'} onClick={handleSearch}>
                <Text fontSize="md" fontWeight="bold" cursor="pointer">
                  Tìm kiếm
                </Text>
              </Button>
              <Button maxH="40px" alignSelf={'end'} onClick={handleReset}>
                <Text fontSize="md" fontWeight="bold" cursor="pointer">
                  Đặt lại
                </Text>
              </Button>
            </Flex>
          </CardHeader>
          <CardBody overflowX="auto">
            <Stack overflow={'auto'}>
              <Table notificationsData={notification?.data || []} refetch={refetch} />
            </Stack>
            <Flex justifyContent={'flex-end'}>
              {!isEmpty(notification?.data) && (
                <Pagination
                  page={notification?.pagination?.page}
                  pageLength={notification?.pagination?.pageSize}
                  totalRecords={notification?.pagination?.count}
                  onPageChange={(page, pageLength) => {
                    setFilter({
                      ...filter,
                      pageSize: pageLength,
                      pageIndex: page - 1,
                    });
                  }}
                />
              )}
            </Flex>
          </CardBody>
        </Card>
      </Flex>
      {/* {isCreateModalOpen && (
          <CreateSizeModal sizeDetail={sizeEditing} isOpen={isCreateModalOpen} onClose={handelCloseModal} refetch={refetch} />
        )} */}
    </>
  );
}
